/**
 * Error types for guest prep check storage failures
 */
export enum GuestStorageError {
    STORAGE_UNAVAILABLE = 'STORAGE_UNAVAILABLE',
    QUOTA_EXCEEDED = 'QUOTA_EXCEEDED',
    INVALID_DATA = 'INVALID_DATA',
    SAVE_FAILED = 'SAVE_FAILED',
}

export interface GuestStorageSaveResult {
    success: boolean
    error?: GuestStorageError
    errorMessage?: string
}
